import qc from 'qc'
import {
  generateLayoutData,
  getLayoutData, getLayoutOmitKeys,
  LAYOUT_RESOLUTION,
  updateLayoutData
} from '@ps/bridge/qc/scripts/layout'
import { getScreenAdapter } from '@ps/bridge/qc/scripts/editor'
import { isImportNode } from '@ps/bridge/qc/base'
import _ from 'lodash'

/**
 * 通过分辨率下的 x/y 值更新改分辨率的 layoutData
 * @param node 节点
 * @param anotherResolution 分辨率
 * @param localPos x/y 值
 */
export const updateAnotherResolutionLayout = ({ node, anotherResolution, localPos }: {
  node: qc.Node,
  anotherResolution: LAYOUT_RESOLUTION,
  localPos: { x: number, y: number }
}): void => {
  const layoutData = getLayoutData(node, anotherResolution)
  // 如果节点或者父级是导入的，则不需要更新
  // 因为历史素材的 layout 无法通过新版的 layout 反推计算
  if (isImportNode(node) || isImportNode(node.parent)) {
    console.log('节点是导入节点，无法重新计算')
    return
  }
  if (!layoutData) {
    console.log('anotherResolution 没有 layout 信息，不做处理')
    return
  }
  // 只有对有 layoutData 的元素生效，如果没有 layoutData 数据，则不做处理
  if (layoutData) {
    const screenAdapter = getScreenAdapter(node, anotherResolution)
    const newLayoutData = generateLayoutData({
      node: node,
      resolution: anotherResolution,
      horizontal: screenAdapter!.horizontal,
      vertical: screenAdapter!.vertical,
      forcedValue: localPos
    })
    const omitKeys = getLayoutOmitKeys(node)
    updateLayoutData({
      node: node,
      resolution: anotherResolution,
      data: _.omit(newLayoutData, omitKeys),
      setAndRefresh: false
    })
  }
}
